export default __webpack_public_path__ + "static/media/icon-plus.b297868c.svg";